/**
 * Shared agent-facing enums/unions used across entrypoints.
 *
 * Keep these as const arrays so consumers can both:
 * - derive TypeScript union types (e.g. `type AgentHint = ...`)
 * - enumerate them at runtime (e.g. `z.enum(AGENT_HINTS)`)
 */

export const AGENT_SERVICE_REQUEST_TYPES = [
  'user_prompt',
  'tool_result',
] as const;
export type AgentServiceRequestType =
  (typeof AGENT_SERVICE_REQUEST_TYPES)[number];

export const AGENT_HINTS = {
  AIA: 'aia',
  VCC: 'vcc',
  ORION: 'orion',
  IMAGE: 'image',
  CONTENT_GAP: 'content-gap',
  FILESYSTEM: 'filesystem',
  COMBINED_AIA_FS: 'combined-aia-fs',
  BRIEF_EDITOR: 'brief-editor',
  SLACK: 'slack',
} as const;

export type AgentHint = (typeof AGENT_HINTS)[keyof typeof AGENT_HINTS];

// Surfaces scope persisted sessions for latest-session lookup.
// AICC uses its own persisted surface, while the current assistant restore flow
// reads both AIA and AICC so opening the panel restores the latest thread.
export const SURFACES = {
  AIA: 'aia',
  AICC: 'aicc',
} as const;

export type Surface = (typeof SURFACES)[keyof typeof SURFACES];

export const MODERATION_FLAGGED_OPERATION = 'moderation_flagged';
export const MODERATION_FLAGGED_MESSAGE =
  'Your message may not align with our usage policies. Try rephrasing your request.';
